import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { college } from '@app/_models/college';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class CollegeService {
  url: string;
  constructor(private http: HttpClient) { }

  getCollege() {
    var temp = this.http.get<any>(`${environment.apiUrl}/college/getList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  

  addCollege(collegeParam: college): Observable<college> {
    return this.http.post<college>(`${environment.apiUrl}/college/collegeAdd`,collegeParam, httpOptions).pipe( );
  }

  updateCollege(collegeParam: college): Observable<college> {
    return this.http.post<college>(`${environment.apiUrl}/college/collegeUpdate`,collegeParam, httpOptions).pipe( );
  }

  deleteCollege(id) {
    return this.http.delete<college>(`${environment.apiUrl}/college/deleteCollegeById/`+id, httpOptions).pipe( );
  }


}